import classNames from 'classnames';
import { Link } from 'react-router';

import { getStatus, SUBMISSION_STATUS } from 'my-core/quiz-utils';

import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

import {
  faCheckCircle,
  faCircle,
  faExclamationCircle,
  faPenSquare,
  faRedoAlt,
  faTimesCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette, shape: { borderRadius }, spacing }) => ({
  padding: spacing(1),
  display: 'flex',
  alignItems: 'flex-start',
  '.PMSN-primaryBtn': {
    flex: '0 0 auto',
    marginRight: spacing(2),
  },
  '.PMSN-links': {
    textAlign: 'right',
    margin: -1,
    marginLeft: 'auto',
  },
  '.PMSN-link': {
    padding: spacing(0.5, 1),
    margin: 1,
    alignItems: 'center',
    borderRadius,
    backgroundColor: palette.background.paper2,
    border: `1px solid ${palette.divider}`,
    '&:hover': { backgroundColor: palette.primary.background },
  },
  '.PMSN-link_active': {
    background: palette.primary.background,
    borderColor: palette.primary.main,
  },
  '.PMSN-btnNumber': { width: 20, textAlign: 'center' },

  ...palette.mapColors(c => ({ [`.PMSN-color_${c}`]: { color: palette[c].main } })),
});

const STATUS_CONFIG = {
  [SUBMISSION_STATUS.ANSWERED]: { color: 'primary', icon: faPenSquare },
  [SUBMISSION_STATUS.CORRECT]: { color: 'success', icon: faCheckCircle },
  [SUBMISSION_STATUS.INCORRECT]: { color: 'error', icon: faTimesCircle },
  [SUBMISSION_STATUS.MARK_SELF]: { color: 'yellow', icon: faExclamationCircle },
  [SUBMISSION_STATUS.SKIPPED]: { color: 'orange', icon: faRedoAlt },
  [SUBMISSION_STATUS.UNANSWERED]: { color: 'skyblue', icon: faPenSquare },
  [SUBMISSION_STATUS.UNSEEN]: { icon: faPenSquare },
};

export default function PracticeModeSectionNavigation({
  activeQuestionId,
  isNewQuestion,
  primaryButtonProps,
  remainingQuestions,
  submissions,
}) {
  return (
    <div css={rootCss}>
      {primaryButtonProps && (
        <Button
          {...primaryButtonProps}
          className="PMSN-primaryBtn"
          onClick={() => primaryButtonProps.onClick?.('top')}
          size="small"
          variant="contained"
        />
      )}
      <div className="PMSN-links">
        {submissions.map(renderSubmissionLink)}
        {!!remainingQuestions && (
          <ButtonBase
            className={classNames('PMSN-link', {
              'PMSN-link_active': isNewQuestion,
            })}
            component={Link}
            nativeButton={false}
            to={{ search: '' }}
          >
            <FontAwesomeIcon fixedWidth icon={faCircle} />
            <Typography className="PMSN-btnNumber" variant="body2">
              {submissions.length + 1}
            </Typography>
          </ButtonBase>
        )}
        {/*[...Array(40)].map((_, idx) => (
          <ButtonBase
            key={idx}
            className="PMSN-link"
            component={Link}
            to={{ search: '' }}
          >
            <FontAwesomeIcon icon={faCircle} fixedWidth />
            <Typography className="PMSN-btnNumber" variant="body2">
              {idx + 1}
            </Typography>
          </ButtonBase>
        ))*/}
      </div>
    </div>
  );

  function renderSubmissionLink(qqs, idx) {
    const status = getStatus(qqs.current_submission, qqs.quiz_question);
    const statusConfig = STATUS_CONFIG[status];
    return (
      <ButtonBase
        key={qqs.id}
        className={classNames('PMSN-link', { 'PMSN-link_active': activeQuestionId === qqs.quiz_question_id })}
        component={Link}
        nativeButton={false}
        to={{ search: `qid=${qqs.quiz_question_id}` }}
      >
        <FontAwesomeIcon
          className={classNames({ [`PMSN-color_${statusConfig.color}`]: statusConfig.color })}
          fixedWidth
          icon={statusConfig.icon}
        />
        <Typography className="PMSN-btnNumber" variant="body2">
          {idx + 1}
        </Typography>
      </ButtonBase>
    );
  }
}
